import React, { FunctionComponent } from 'react';
import { IMenuSelectEventData } from '@tylertech/forge';
import { ForgeMenu, ForgeIcon, ForgeIconButton } from '@tylertech/forge-react';
import './index.scss';

const LanguageSwitcher: FunctionComponent = () => {
  const { availableLocales } = window.socrata;

  const options = availableLocales
    ? availableLocales.map((locale) => ({
        value: locale.url,
        label: locale.text,
        elementAttributes: new Map([
          ['class', 'language-option'],
          ['data-test-id', `language-switcher-${locale.url}`],
        ]),
      }))
    : null;
  const onMenuSelect = ({ detail }: CustomEvent<IMenuSelectEventData>) => {
    window.open(`${detail.value}`, '_self');
  };

  return (
    <>
      <ForgeMenu options={options} on-forge-menu-select={onMenuSelect} data-test-id="omnibar-language-picker">
        <ForgeIconButton aria-label="View user profile" className="tyler-icons">
          <ForgeIcon name="translate" />
        </ForgeIconButton>
      </ForgeMenu>
    </>
  );
};

export default LanguageSwitcher;
